export const USERS_API = '/api/v1/users';

export const INVITATIONS_API = '/api/v1/invitations';

export const ROLES_PATH = 'roles';
